import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "axios";

const Meting = () => {
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.language;

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    countryCode: "",
    phoneNumber: "",
    paymentMethod: "",
    price: 500,
    serveicename: "طلب اجتماع"
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePhoneChange = (value, data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      countryCode: data.dialCode,
      phoneNumber: value.slice(data.dialCode.length),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.post("https://demo-two.keytime.sa/api/payment", formData, {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language,
        },
      });

      const res_payment = response.data.paymentUrl;
      if (res_payment.startsWith("http")) {
        window.location.href = res_payment;
      } else {
        toast.error(res_payment, { position: "top-center", duration: 5000 });
      }
    } catch (error) {
      console.error("Error", error);
      setError(error.response?.data?.message || "حدث خطأ ما");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full lg:py-16 flex justify-center">
      <div className={`w-[50%] border rounded-md py-4 px-4 ${activeLanguage === "ar" ? "text-right" : "text-left"}`}>
        <h1 className="text-center pb-5 font-bold text-[22px]">
          {t("cartFormTitle")}
        </h1>
        <p className="text-center font-semibold">{activeLanguage === "ar" ? "اسم الخدمة" : "service Name"} : {activeLanguage === "ar" ? "طلب اجتماع" : "Meeting Request"}</p>

        <p className="text-center font-semibold">{activeLanguage === "ar" ? "السعر" : "price"} : 500</p>
        <div className="w-full gap-2 flex flex-col">
          <form
            onSubmit={handleSubmit}
            className={`w-full flex ${
              activeLanguage === "ar" ? "justify-end items-end text-end" : ""
            } flex-col gap-4`}
          >
            {/* Input for Full Name */}
            <label className="justify-end text-end w-full flex items-center gap-2 hover:border px-4 py-2 active:border rounded-lg outline outline-1">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={`grow outline-none bg-transparent border-none ${
                  activeLanguage === "ar" ? "text-end justify-end" : ""
                } w-full`}
                placeholder={t("fullName")}
                required
              />
            </label>

            {/* Input for Email */}
            <div className="w-full gap-2 flex flex-col">
              <p>{t("emailform")}</p>
              <label className="justify-end text-end w-full flex items-center gap-2 hover:border px-4 py-2 active:border rounded-lg outline outline-1">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={`grow outline-none bg-transparent border-none ${
                    activeLanguage === "ar" ? "text-end justify-end" : ""
                  } w-full`}
                  placeholder={t("emailform")}
                  required
                />
              </label>
            </div>

            {/* Input for Phone */}
            <div className="w-full gap-2 flex flex-col">
              <p>{t("phone")}</p>
              <label
                htmlFor=""
                className="justify-start text-end w-full flex items-center gap-2 hover:border px-4 py-2 active:border rounded-lg outline outline-1"
              >
                <div className="flex justify-start items-start left-0">
                  <PhoneInput
                    country={"sa"}
                    value={formData.phone_number}
                    onChange={handlePhoneChange}
                    inputStyle={{
                      border: "none",
                      gap: 0,
                      justifyContent: "start",
                      width: "200px",
                    }}
                    className={`grow outline-none bg-transparent border-none ${
                      activeLanguage === "ar" ? "text-end justify-end" : ""
                    } w-full`}
                    name="phone_number"
                    required
                  />
                </div>
              </label>
            </div>

            {/* Payment Methods */}
            <div className="w-full flex flex-col">
              <p>{t("payment method")}</p>
              <div
                className={`flex flex-col ${
                  activeLanguage === "ar" ? "items-end" : "items-start"
                } space-y-0`}
              >
                {/* Mada */}
                <label
                  className={`flex items-center w-full cursor-pointer ${
                    activeLanguage === "ar" ? "flex-row-reverse" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="mada"
                    onChange={handleChange}
                    required
                    className="w-5 h-5 m-0"
                  />
                  <img
                    src="\Images\mada-logo.png"
                    alt="Mada"
                    className="w-20 h-20"
                  />
               
                </label>

                {/* Tabby */}
                <label
                  className={`flex items-center w-full cursor-pointer ${
                    activeLanguage === "ar" ? "flex-row-reverse" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="tabby"
                    onChange={handleChange}
                    required
                    className="w-5 h-5 m-0"
                  />
                  <img
                    src="\Images\tabby-logo.png"
                    alt="Tabby"
                    className="w-20 h-20"
                  />
                  <span className="text-gray-700">
                    {t("قسّمها على 4 بدون أي فوائد، أو رسوم")}
                  </span>
                </label>

                <label
                  className={`flex items-center w-full cursor-pointer ${
                    activeLanguage === "ar" ? "flex-row-reverse" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="ApplePay"
                    onChange={handleChange}
                    required
                    className="w-5 h-5 m-0"
                  />
                  <img
                    src="\Images\ApplePay-logo.png"
                    alt="ApplePay"
                    className="w-20 h-20"
                  />
               
                </label>

             
              </div>
            </div>

            {/* Error Message */}
            {error && <p className="text-red-500">{error}</p>}

            {/* Submit Button */}
            <button
              type="submit"
              className={`btn bg-[#003E6F] hover:bg-[#b6953e] w-full text-white ${
                formData.price === 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={isLoading || formData.price === 0}
            >
              {isLoading ? "Loading..." : t("buy")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );


};

export default Meting;
